module.exports = __webpack_public_path__ + "img/c8734ec.jpg";